import { Sparkle, MapPin, Phone, Clock } from "lucide-react";
import { SITE, SERVICES } from "../config/site";

export const Footer = ({ onNavigate }) => {
  const links = [
    { label: "Services", id: "services" },
    { label: "Gallery", id: "gallery" },
    { label: "Reviews", id: "reviews" },
    { label: "FAQ", id: "faq" },
    { label: "Contact", id: "contact" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-brand-deep text-white/80">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.3fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
              <Sparkle size={16} className="text-brand-goldlight" aria-hidden="true" />
            </span>
            <div>
              <p className="font-serif text-xl font-bold text-white leading-none">Lagom</p>
              <p className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-0.5">
                Unisex Salon
              </p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-xs">
            Premium yet affordable hair, beauty and spa services in
            Electronic City — where hygiene, craft and calm come standard.
          </p>
        </div>

        <nav aria-label="Footer">
          <h3 className="text-sm font-semibold tracking-[0.18em] uppercase text-brand-goldlight">
            Explore
          </h3>
          <ul className="mt-5 space-y-3">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => onNavigate(l.id)}
                  className="text-sm text-white/60 hover:text-brand-goldlight transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-semibold tracking-[0.18em] uppercase text-brand-goldlight">
            Lagom
          </h3>
          <ul className="mt-5 space-y-3">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.name} className="text-sm text-white/60">
                {s.name}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold tracking-[0.18em] uppercase text-brand-goldlight">
            Visit
          </h3>
          <ul className="mt-5 space-y-4 text-sm text-white/60">
            <li className="flex gap-3">
              <MapPin size={16} className="shrink-0 mt-0.5 text-brand-gold" aria-hidden="true" />
              <span>{SITE.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="shrink-0 mt-0.5 text-brand-gold" aria-hidden="true" />
              <a href={SITE.phoneHref} className="hover:text-brand-goldlight transition-colors">
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="shrink-0 mt-0.5 text-brand-gold" aria-hidden="true" />
              <span>{SITE.hours}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40 pb-24 md:pb-6">
          <p>© {new Date().getFullYear()} Lagom Unisex Salon. All rights reserved.</p>
          <p>Crafted with care in Bangalore.</p>
        </div>
      </div>
    </footer>
  );
};
